import { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatText } from '../../../../../../helpers/value'
import { selectUserType } from '../../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../../utils/authorization'

export const FactSheetDescription = ({ val, rowId, getDataFromRedux }) => {
  const dataBlocks = useSelector(getDataFromRedux(rowId, 'dataBlocks'))
  const userType = useSelector(selectUserType)

  const isFullData = [USER_TYPE.STANDARD, USER_TYPE.PREMIUM].includes(
    userType?.userTypeId,
  )

  return (
    <div className="flexColumn" style={{ gap: 4 }}>
      <Translate
        value="userManagement.orderManagement.orderDetail.AVAILABLE_FS_DATA"
        className="fw600"
      />
      {formatText(val)}
      {isFullData ? (
        <DataFull dataBlocks={dataBlocks} />
      ) : (
        <DataBlocks dataBlocks={dataBlocks} />
      )}
    </div>
  )
}

export const DataFull = ({ dataBlocks }) => {
  const checkAvailabilities = dataBlocks.find((item) => item?.dataBlockId === 3)

  if (!checkAvailabilities?.dataAvailabilities?.length) return <></>

  return (
    <>
      <Translate value="common.order.factSheet.FS_SETTINGS" className="fw600" />
      {dataBlocks.map((block, index) => {
        if (block.dataBlockId === 3) {
          return (
            <div key={index}>
              <div className="flexColumn" style={{ marginLeft: 8 }}>
                <span>{formatText(block.reportSourceName)}</span>
                {block.consolidated ? (
                  <Translate value="userManagement.orderManagement.orderDetail.CONSOLIDATED" />
                ) : (
                  <Translate value="userManagement.orderManagement.orderDetail.UNCONSOLIDATED" />
                )}

                {block?.dataAvailabilities.map((item, index) => {
                  return (
                    <span key={index}>
                      {item.year}:&nbsp;
                      {item.audited ? (
                        <Translate value="userManagement.orderManagement.orderDetail.AUDITED" />
                      ) : (
                        <Translate value="userManagement.orderManagement.orderDetail.UNAUDITED" />
                      )}
                      ,&nbsp;
                      {item.isDirect ? (
                        <Translate value="userManagement.orderManagement.orderDetail.DIRECT" />
                      ) : (
                        <Translate value="userManagement.orderManagement.orderDetail.INDIRECT" />
                      )}
                    </span>
                  )
                })}
              </div>
            </div>
          )
        }
        return <Fragment key={index} />
      })}
    </>
  )
}

export const DataBlocks = ({ dataBlocks }) => {
  const checkAvailabilities = dataBlocks.find((item) => item?.dataBlockId === 3)

  return (
    <>
      <Translate
        value="userManagement.orderManagement.orderDetail.SELECTED_DATA_BLOCKS"
        className="fw600"
      />
      {dataBlocks.map((block, index) => {
        if (block.dataBlockId === 3) {
          if (!checkAvailabilities?.dataAvailabilities?.length)
            return <Fragment key={index} />
          return (
            <div style={{ marginLeft: 10 }} key={index}>
              {block.dataBlockName}:
              <div className="flexColumn" style={{ marginLeft: 8 }}>
                <span>{formatText(block.reportSourceName)}</span>
                {block.consolidated ? (
                  <Translate value="userManagement.orderManagement.orderDetail.CONSOLIDATED" />
                ) : (
                  <Translate value="userManagement.orderManagement.orderDetail.UNCONSOLIDATED" />
                )}

                {block?.dataAvailabilities.map((item, index) => {
                  return (
                    <span key={index}>
                      {item.year}:&nbsp;
                      {item.audited ? (
                        <Translate value="userManagement.orderManagement.orderDetail.AUDITED" />
                      ) : (
                        <Translate value="userManagement.orderManagement.orderDetail.UNAUDITED" />
                      )}
                      ,&nbsp;
                      {item.isDirect ? (
                        <Translate value="userManagement.orderManagement.orderDetail.DIRECT" />
                      ) : (
                        <Translate value="userManagement.orderManagement.orderDetail.INDIRECT" />
                      )}
                    </span>
                  )
                })}
              </div>
            </div>
          )
        }

        return (
          <div style={{ marginLeft: 10 }} key={index}>
            {block.dataBlockName}
          </div>
        )
      })}
    </>
  )
}
